import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { useAuth } from "@/shared/auth/useAuth";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { updatePreferences } = useAuth();

  const toggle = () => {
    const next = i18n.language === "en" ? "es" : "en";
    i18n.changeLanguage(next);
    // Keep localStorage as fast cache for initial page load
    localStorage.setItem("i18n_language", next);
    // Persist to DB so it syncs across devices
    updatePreferences({ locale: next });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggle}
      aria-label="Switch language"
      className="gap-1.5 text-xs font-medium"
    >
      <Globe className="h-4 w-4" />
      {i18n.language === "en" ? "ES" : "EN"}
    </Button>
  );
}
